import {ICalSubscriptionConnection} from '@package/shared'
import type {z} from 'zod'

export const FormValues = ICalSubscriptionConnection.pick({
  name: true,
  url: true,
  projectId: true,
})
export type FormValues = z.infer<typeof FormValues>
